<script setup lang="ts">
import { ClickOutside as vClickOutside } from 'element-plus';

import { ILang } from '@/types/region';
import { LANGUAGES } from '@/constants';
import { useAppStore } from '@/store/app';
import { gtmChangeLanguage } from '@/utils/helper/gtm';

let popoverVisible = ref(false);

const appStore = useAppStore();
const { setLocale } = useI18n();

const userLanguage = computed(() => {
	return appStore.getLanguage;
});

const selectLanguage = async (lang: ILang) => {
	if (lang.value === userLanguage.value.value) return;
	appStore.updateLanguage(lang);
	appStore.setDetectedLanguage(lang.value);
	setLocale(lang.value);
	gtmChangeLanguage(lang.value);
};

const hidePopover = () => {
	popoverVisible.value = false;
};
</script>
<template>
	<div class="select-language">
		<el-popover
			placement="bottom"
			:width="240"
			:visible="popoverVisible"
			popper-class="language-selection-popover"
		>
			<div class="language-selection-popover-content">
				<div
					v-for="language in LANGUAGES"
					:key="language.value"
					:class="['language-item', { 'is-active': userLanguage.value === language.value }]"
					@click="selectLanguage(language)"
				>
					<div>{{ language.label }}</div>
					<nuxt-icon v-if="userLanguage.value === language.value" name="check" class="icon-check"></nuxt-icon>
				</div>
			</div>
			<template #reference>
				<div
					v-click-outside="hidePopover"
					class="language-selection-btn"
					@click="popoverVisible = !popoverVisible"
				>
					<nuxt-icon name="globe" class="icon-globe"></nuxt-icon>
					<div class="language-name noselect">{{ userLanguage.value }}</div>
					<nuxt-icon name="arrow-down" :class="['icon-arrow', { 'is-active': popoverVisible }]"></nuxt-icon>
				</div>
			</template>
		</el-popover>
	</div>
</template>
<style lang="scss" scope>
@import '@/assets/scss/components/select-language.scss';
</style>
